import { render } from "./ConflictResolutionCard.vue?vue&type=template&id=574beeb2&scoped=true"
import script from "./ConflictResolutionCard.vue?vue&type=script&lang=js"
export * from "./ConflictResolutionCard.vue?vue&type=script&lang=js"

import "./ConflictResolutionCard.vue?vue&type=style&index=0&id=574beeb2&scoped=true&lang=css"

import exportComponent from "../../../../../procollege/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-574beeb2"]])

export default __exports__